import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { categories } from "../../data/products";

export default function Categories() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-[#DB5461]/10 to-transparent" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-1.5 mb-4 text-sm font-medium tracking-wider text-gold-500 bg-gold-50 rounded-full">
            COLLECTIONS
          </span>
          <h2 className="text-4xl font-serif font-bold text-primary-900 mb-4">
            Discover Our Categories
          </h2>
          <div className="w-24 h-1 bg-[#DB5461] mx-auto rounded-full" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <Link
                to={`/products?category=${category.name.toLowerCase()}`}
                className="block group"
              >
                <motion.div
                  whileHover={{ y: -5 }}
                  className="relative rounded-xl overflow-hidden shadow-soft hover:shadow-medium transition-all duration-300"
                >
                  <div className="relative aspect-[4/5] overflow-hidden">
                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.6 }}
                      className="w-full h-full"
                    >
                      <img
                        src={category.image}
                        alt={category.name}
                        className="w-full h-full object-cover"
                      />
                    </motion.div>
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-all duration-300" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300" />

                    {/* Decorative Elements */}
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute top-0 left-0 w-full h-1/3 bg-gradient-to-b from-[#DB5461]/20" />
                      <div className="absolute bottom-0 right-0 w-full h-1/3 bg-gradient-to-t from-[#DB5461]/20" />
                    </div>

                    <div className="absolute inset-0 flex flex-col justify-end p-8 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <motion.div
                        initial={{ y: 20, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2 }}
                      >
                        <h3 className="text-2xl font-serif font-bold text-white mb-2 group-hover:text-white transition-colors duration-300 drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)]">
                          {category.name}
                        </h3>
                        <p className="text-gray-100 group-hover:text-white transition-colors duration-300 drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)]">
                          {category.description}
                        </p>
                        <div className="mt-4 inline-flex items-center text-[#DB5461] text-sm font-medium">
                          Explore Collection
                          <svg
                            className="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </div>
                      </motion.div>
                    </div>
                  </div>
                  <div className="mt-4 text-center">
                    <h3 className="text-lg font-serif font-bold text-primary-900">
                      {category.name}
                    </h3>
                  </div>
                </motion.div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
